import React, { PureComponent } from "react";
import { NavLink as RouteLink } from "react-router-dom";
import PropTypes from "prop-types";
import "./RouteButton.css";

class RouteButton extends PureComponent {
  render() {
    return (
      <RouteLink
        onClick={() =>
          this.props.click_function(this.props.ga_category, this.props.ga_name)}
        activeClassName="highlighted"
        to={this.props.linkTo}
        className={this.props.class_names}
      >
        {this.props.buttonText}
      </RouteLink>
    );
  }
}
RouteButton.propTypes = {
  click_function: PropTypes.func,
  linkTo: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  ga_name: PropTypes.string,
  ga_category: PropTypes.string,
  class_names: PropTypes.string
};

RouteButton.defaultProps = {
  click_function: () => {},
  ga_name: "",
  ga_category: "",
  class_names: "btn btn-outline btn-xl"
};

export default RouteButton;



// WEBPACK FOOTER //
// ./src/components/RouteButton/RouteButton.jsx